export default __webpack_public_path__ + "static/media/home-about-us.34b1594a.mp4";